import React, { useEffect, useState } from "react";
import "./TimeSlotHeatmap.css";
import { ToggleButtonGroup, ToggleButton } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
// import { fetchTimeSlotPopularity } from "src/redux/slices/timeSlotSlice"; // Adjust path
import { fetchTimeSlotPopularity } from "../../../../redux/reducers/timeSlotSlice";
const dayMapping = {
  Sunday: "Sun",
  Monday: "Mon",
  Tuesday: "Tues",
  Wednesday: "Wed",
  Thursday: "Thurs",
  Friday: "Fri",
  Saturday: "Sat",
};

const getColorClass = (category) => {
  switch (category) {
    case "More": return "high";
    case "Medium": return "medium";
    case "Low": return "low";
    default: return "";
  }
};

export default function TimeSlotHeatmap() {
  const dispatch = useDispatch();
  const { timeSlotsData, loading } = useSelector((state) => state.timeSlot);
  const [view, setView] = useState("Weekly");

  const [gridData, setGridData] = useState([]);
  const [timeSlots, setTimeSlots] = useState([]);
  const [days, setDays] = useState([]);

  useEffect(() => {
    dispatch(fetchTimeSlotPopularity());
  }, [dispatch]);

  useEffect(() => {
    if (!timeSlotsData || loading) return;

    // Extract unique time slots from API data
    const extractedTimeSlots = Object.keys(timeSlotsData).sort();

    // Map days of the week
    const extractedDays = [
      "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"
    ].map(day => dayMapping[day]);

    // Initialize grid data
    const grid = extractedTimeSlots.map((slot) => {
      const slotData = timeSlotsData[slot];
      return extractedDays.map((dayShort) => {
        const fullDay = Object.keys(slotData).find(day =>
          day.startsWith(dayShort.slice(0, 3))
        );
        return {
          count: slotData?.[fullDay]?.count || 0,
          category: slotData?.[fullDay]?.category || "Low",
        };
      });
    });

    setTimeSlots(extractedTimeSlots);
    setDays(extractedDays);
    setGridData(grid);
  }, [timeSlotsData, loading]);

  return (
    <div className="heatmap-container">
      {/* <div className="heatmap-header">
        <h3>Time Slot Popularity</h3>
        <ToggleButtonGroup
          value={view}
          exclusive
          onChange={(_, val) => val && setView(val)}
          size="small"
          sx={{
            backgroundColor: '#f0f2f5',
            borderRadius: '12px',
            '& .MuiToggleButtonGroup-grouped': {
              borderRadius: '7px',
              borderColor: 'transparent',
              color: '#333',
              fontWeight: 500,
              '&.Mui-selected': {
                backgroundColor: '#005EB8',
                color: '#fff',
              },
            },
          }}
        >
          <ToggleButton value="Weekly">Week</ToggleButton>
          <ToggleButton value="Monthly">Month</ToggleButton>
        </ToggleButtonGroup>
      </div> */}
      <div className="heatmap-header">
  <div className="left-section">
    <h3>Time Slot Popularity</h3>
  </div>

  <ToggleButtonGroup
    value={view}
    exclusive
    onChange={(_, val) => val && setView(val)}
    size="small"
    sx={{
      backgroundColor: '#f0f2f5',
      borderRadius: '12px',
      '& .MuiToggleButtonGroup-grouped': {
        borderRadius: '7px',
        borderColor: 'transparent',
        color: '#333',
        fontWeight: 500,
        '&.Mui-selected': {
          backgroundColor: '#005EB8',
          color: '#fff',
        },
      },
    }}
  >
    <ToggleButton value="Weekly">Week</ToggleButton>
    <ToggleButton value="Monthly">Month</ToggleButton>
  </ToggleButtonGroup>
</div>

      <div className="heatmap-legend">
        <span><span className="dot high"></span> More bookings</span>
        <span><span className="dot medium"></span> Medium bookings</span>
        <span><span className="dot low"></span> Fewer bookings</span>
      </div>

      <div className="heatmap-grid">
        {/* Header Row */}
        <div className="empty-cell" />
        {days.map((day) => (
          <div className="header-cell" key={day}>{day}</div>
        ))}

        {/* Data Rows */}
        {timeSlots.map((slot, rowIndex) => (
          <>
            <div className="time-cell">{slot}</div>
            {gridData[rowIndex]?.map((cell, colIndex) => (
              <div
                key={`${rowIndex}-${colIndex}`}
                className={`booking-cell ${getColorClass(cell.category)}`}
              >
                {cell.count}
              </div>
            ))}
          </>
        ))}
      </div>
    </div>
  );
}